const members = {
    jon: {
        name: 'Jon Rhoades',
        email: 'jon@valid.care',
        role: 'Technical Co-Founder',
        bio: 'Jon is a software engineer and technical co-founder of Valid. He is passionate about building great products and solving complex problems.',
        image: '/jon.jpg',
        vCard: '/jon_vcard.vcf',
        calendly: 'https://calendly.com/_valid',
        mobile: '(402)410-1380',
        linkedIn: 'https://www.linkedin.com/in/jon-rhoades/',
    },
    chase: {
        name: 'Chase Francl',
        email: 'chase@valid.care',
        role: 'Business Co-Founder',
        bio: 'Chase is a business co-founder of Valid and is passionate about improving the healthcare industry through better processes.',
        image: '/chase.jpg',
        vCard: '/chase_vcard.vcf',
        calendly: 'https://calendly.com/_valid',
        mobile: '(308)940-0040',
        linkedIn: 'https://www.linkedin.com/in/chase-francl-3342b2b1/',
    }
}

export default members